/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ClientAdapter.tsx
 */

import ListAdapter, {AdapterListener} from "../../tools/list/ListAdapter";
import User from "../../models/User";
import React from "react";
import {Column} from "../../tools/list/Column"
import Translation from "../../services/translation/Translation";
import UserDataProvider from "../../provider/UserDataProvider";
import {UserAPIPagination} from "../../pagination/UserAPIPagination";
import {Role} from "../../tools/model/enumerations/Role";
import {Criterion} from "../../tools/model/pagination/Criterion";

export interface UserAdapterListener extends AdapterListener<User> {
}

export default class UserAdapter extends ListAdapter<User, UserAdapterListener, UserAPIPagination> {
    private _t: Translation;

    /**
     * constructor
     * @param listener
     * @param t
     * @param userProvider
     */
    constructor(t: Translation, userProvider: UserDataProvider, listener?: UserAdapterListener) {
        super();

        this._t = t;
        this.addColumn(new Column(t.userListColID, "email", this._mail));
        this.addColumn(new Column(t.userListColLastName, "lastname", this._name));
        this.addColumn(new Column(t.userListColRole, "id", this._role));
        this.addColumn(new Column(t.clientListColEnabled, "enabled", this._enabled));
        this.addColumn(new Column(t.clients, "id", this._clients));

        this.init(
            t.userListEmpty,
            userProvider,
            Object.values(Role).map(r => new Criterion("role", r.toString(), r.toString())),
            listener
        );

        this.criteria.unshift({relatedFilterKey: "role", translationKey: "all", value: "all"})
    }

    /**
     * _name
     * @returns {any}
     * @private
     * @param user
     */
    private _name = (user: User): JSX.Element => {
        return <p>{user.firstname}<span style={{fontWeight: 600}}> {user.lastname}</span></p>
    };

    /**
     * _mail
     * @returns {any}
     * @private
     * @param user
     */
    private _mail = (user: User): JSX.Element => {
        return <p className={"blue-hover"}>{user.email || "N/A"}</p>
    };

    /**
     * _role
     * @returns {any}
     * @private
     * @param user
     */
    private _role = (user: User): JSX.Element => {
        return <p>{user.roles.join(", ")}</p>
    };

    /**
     * _enabled
     * @returns {any}
     * @private
     * @param user
     */
    private _enabled = (user: User): JSX.Element => {
        return <input type="checkbox" readOnly checked={user.enabled}/>
    };

    /**
     * _clients
     * @returns {any}
     * @private
     * @param user
     */
    private _clients = (user: User): JSX.Element => {
        return <p style={{fontWeight: 800, color: user.clients.length === 0 ? "#FF0000" : "#000000"}}>
            {user.clients.length}
        </p>
    };
}